// extracted by mini-css-extract-plugin
module.exports = {"title":"related-articles-slider_title__t0MlP","sliderItem":"related-articles-slider_sliderItem__GaxDF"};